import { OrderListResponseType } from "@sellar-io/api-v2/types";

import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";

import { ORDER_DETAILS, ORDERS } from "../../../../constants/routes";

export const getOrderDetailsRedirectUrl = ({
  orderId,
  isTwoPanel,
  query,
}: {
  orderId: number | null;
  isTwoPanel: boolean;
  query: UseInfiniteQueryResult<InfiniteData<OrderListResponseType>>;
}) => {
  if (
    isTwoPanel &&
    query.data?.pages[0]?.length &&
    // If there is no order ID OR you have just swapped tabs, redirect to first item in the query
    !orderId
  ) {
    //if two panel layout and no orders selected, automatically select first order
    const firstOrder = query.data.pages[0][0];
    const search = location.search;
    return firstOrder
      ? `${ORDER_DETAILS.href({ orderId: firstOrder.id })}${search}`
      : `${ORDERS}${search}`;
  }
};
